import React, { FunctionComponent } from "react"
import { iUserBusiness } from "../../../definitions/User"

interface iProps {
  item: iUserBusiness
}

const BusinessLocations: FunctionComponent<iProps> = () => {
  return (
    <div>
      <button>Add Location</button>
      <button>Change Location Order</button>
    </div>
  )
}

export default BusinessLocations
